module.exports = __webpack_public_path__ + "img/imgaddrbtgray.5f4fe15e.png";